import { render } from "./transferts_tab.vue?vue&type=template&id=a4b1fdb2"
import script from "./transferts_tab.vue?vue&type=script&lang=js"
export * from "./transferts_tab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__